export default "__VITE_ASSET__BCTO86zj__"